export default __webpack_public_path__ + "static/media/milestone 15.bcd7c6b9.svg";